import { forwardRef, ReactElement, Ref } from "react";
import { Slide } from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";

export const SlideTransition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement<any, any>;
	},
	ref: Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});
